import React from 'react';

import Icon from './Icon';
import Box from './layout/Box';
import Image from './Image';

const BookImage = ({ bookId, source, size, style }) => {
  const aspectRatio = 0.7576;

  const sizeStyle = {
    width: size,
    height: size / aspectRatio,
  };

  if (source) {
    return (
      <Box
        className="flex-shrink-0"
        style={{ borderRadius: 4, overflow: 'hidden', ...sizeStyle }}
      >
        <Image
          alt={`book-${bookId}`}
          source={source}
          className="d-flex"
          style={{ ...sizeStyle, ...style }}
        />
      </Box>
    );
  }

  return (
    <Box
      className="align-items-center flex-shrink-0 justify-content-center"
      backgroundColor="lightBlackColor"
      style={{
        minWidth: 0,
        borderRadius: 4,
        overflow: 'hidden',
        ...sizeStyle,
        ...style,
      }}
    >
      <Icon name="image-outline" color={'#666666'} />
    </Box>
  );
};

export default BookImage;
